import { css } from "styled-components";
import { COLOR_ELEVATION_SHADOW } from "./colors";

const HAIRLINE = `0 0 0 1px ${COLOR_ELEVATION_SHADOW} inset`;
const DROP_SHADOW = `0 2px 8px 0 ${COLOR_ELEVATION_SHADOW}`;

export const ELEVATION_1 = `${HAIRLINE}, ${DROP_SHADOW}`;

export const elevation1Clipped = css`
  position: relative;
  box-shadow: ${DROP_SHADOW};

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: ${HAIRLINE};
    pointer-events: none;
  }
`;
